import AuthService from "@/services/auth.service";

/**
 * Exchanges a Firebase Google user for a backend session, initializing it
 * through AuthService when successful.
 */
export async function exchangeGoogleUserForSession({
  firebaseUser,
  inviteCode,
  stateHandler,
  setLoading,
}) {
  if (!firebaseUser) {
    return { ok: false, reason: "missing-user" };
  }

  let idToken = null;
  try {
    idToken = await firebaseUser.getIdToken();
  } catch (error) {
    console.error("[google-auto-flow] Failed to get ID token", error);
    return { ok: false, reason: "id-token-error", error };
  }

  if (!idToken) {
    return { ok: false, reason: "missing-id-token" };
  }

  const { response, data } = await AuthService.getCustomToken(
    idToken,
    inviteCode
  );
  const errorType = data?.error_type ?? null;

  if (response?.ok) {
    await AuthService.initUserSession(stateHandler, setLoading, data);
    return { ok: true, data };
  }

  if (response?.status === 400 && errorType === "EMAIL_BELONGS_TO_ARTIST") {
    return { ok: false, reason: "email-belongs-to-artist" };
  }

  return {
    ok: false,
    reason: "backend-error",
    status: response?.status ?? null,
    errorType,
  };
}

export default {
  exchangeGoogleUserForSession,
};
